exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n[data-v-0b1d829f] .v-field__input {\n  padding: 0.15rem 0.5rem 0.25rem 0.5rem !important;\n  border: none !important;\n  font-size: 1rem !important;\n}\n", ""]);

// exports
